module.exports = __webpack_public_path__ + "static/feature-skill-browser-050977059a23d0d942236d6e8d48c6ed.svg";